
(function (w, d) {
  'use strict';

  if (w.DJIDataLayer) return;

  w.dataLayer = w.dataLayer || [];

  var CTX = w.__djiTrackingContext || {};
  var DEBUG = false;
  try {
    DEBUG = /[?&]dji_track_debug=1/.test(w.location.search) || w.localStorage.getItem('dji_track_debug') === '1';
  } catch (e) {}

  /* ---------------------------------------------------------------- */
  
  /* ---------------------------------------------------------------- */

  function uuid() {
    try {
      if (w.crypto && typeof w.crypto.randomUUID === 'function') return w.crypto.randomUUID();
    } catch (e) {}
    var t = Date.now();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (t + Math.random() * 16) % 16 | 0;
      t = Math.floor(t / 16);
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  var PAGE_VIEW_ID = uuid();
  var seenPageView = {};

  
  var pageViewResets = [];

  
  function onNewPageView(fn) {
    if (typeof fn === 'function') pageViewResets.push(fn);
  }

  function newPageView() {
    PAGE_VIEW_ID = uuid();
    seenPageView = {};
    w.DJIDataLayer.pageViewId = PAGE_VIEW_ID;
    
    for (var i = 0; i < pageViewResets.length; i++) {
      try { pageViewResets[i](); } catch (e) { log('pageViewReset error', e); }
    }
    log('new page_view', PAGE_VIEW_ID);
    return PAGE_VIEW_ID;
  }

  function log() {
    if (!DEBUG) return;
    try {
      console.log.apply(console, ['%c[DJI dataLayer]', 'color:#526408;font-weight:bold'].concat([].slice.call(arguments)));
    } catch (e) {}
  }

  
  function once(key) {
    if (!key) return true;
    if (seenPageView[key]) return false;
    seenPageView[key] = 1;
    return true;
  }

  
  function onceSession(key) {
    if (!key) return true;
    
    var k = 'dji_tr_' + key;
    try {
      if (w.sessionStorage.getItem(k)) return false;
      w.sessionStorage.setItem(k, '1');
      return true;
    } catch (e) {
      return once(key);
    }
  }

  /* ---------------------------------------------------------------- */
  
  /* ---------------------------------------------------------------- */

  function consent(kind) {
    try {
      var cp = w.Shopify && w.Shopify.customerPrivacy;
      if (cp) {
        if (kind === 'analytics' && typeof cp.analyticsProcessingAllowed === 'function') {
          return !!cp.analyticsProcessingAllowed();
        }
        if (kind === 'marketing' && typeof cp.marketingAllowed === 'function') {
          return !!cp.marketingAllowed();
        }
      }
    } catch (e) {}
    return null; 
  }

  /* ---------------------------------------------------------------- */
  
  /* ---------------------------------------------------------------- */

  var RE_EMAIL = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi;
  
  var RE_PHONE = /(?:\+?\d[\s\-().]?){7,}/g;
  var RE_LONGNUM = /\d{7,}/g;

  function sanitize(text) {
    if (text == null) return '';
    var s = String(text).trim().slice(0, 100);
    if (!s) return '';
    var redacted = false;
    if (RE_EMAIL.test(s)) { RE_EMAIL.lastIndex = 0; redacted = true; }
    RE_EMAIL.lastIndex = 0;
    s = s.replace(RE_EMAIL, '[redacted_email]');
    if (RE_PHONE.test(s)) { RE_PHONE.lastIndex = 0; redacted = true; }
    RE_PHONE.lastIndex = 0;
    s = s.replace(RE_PHONE, '[redacted_phone]');
    RE_LONGNUM.lastIndex = 0;
    s = s.replace(RE_LONGNUM, '[redacted_number]');
    if (redacted) log('search term redacted');
    return s.toLowerCase();
  }

  /* ---------------------------------------------------------------- */
  
  /* ---------------------------------------------------------------- */

  
  function deviceType() {
    var wid = w.innerWidth || d.documentElement.clientWidth || 0;
    if (wid && wid < 768) return 'mobile';
    if (wid && wid < 1024) return 'tablet';
    return 'desktop';
  }

  function commonFields() {
    return {
      event_id: uuid(),
      page_view_id: PAGE_VIEW_ID,
      page_type: CTX.page_type || 'other',
      template_id: CTX.template_id || '',
      page_location: w.location.href,
      page_title: d.title,
      locale: CTX.locale || '',
      currency: CTX.currency || '',
      consent_analytics: consent('analytics'),
      consent_marketing: consent('marketing')
    };
  }

  function clean(obj) {
    var out = {};
    for (var k in obj) {
      if (!Object.prototype.hasOwnProperty.call(obj, k)) continue;
      var v = obj[k];
      
      if (v === undefined || v === null) continue;
      out[k] = v;
    }
    return out;
  }

  
  var ECOM_KEYS = [
    'value', 'items', 'item_list_id', 'item_list_name',
    'coupon', 'transaction_id', 'affiliation', 'shipping', 'tax'
  ];

  
  function push(eventName, payload) {
    if (!eventName) return null;
    var data = clean(payload || {});

    
    var declaresEcom = Object.prototype.toString.call(data.items) === '[object Array]';
    var ecom = null;
    if (declaresEcom) {
      w.dataLayer.push({ ecommerce: null, items: null, value: null });
      ecom = {};
      for (var e = 0; e < ECOM_KEYS.length; e++) {
        var ek = ECOM_KEYS[e];
        if (data[ek] !== undefined) {
          ecom[ek] = data[ek];
          delete data[ek];
        }
      }
    } else if (data.items !== undefined) {
      
      delete data.items;
    }

    var evt = {};
    var common = commonFields();
    for (var c in common) evt[c] = common[c];
    for (var k in data) evt[k] = data[k];
    if (ecom) {
      
      ecom.currency = ecom.currency || common.currency;
      evt.ecommerce = ecom;
      evt.items = ecom.items;
      if (ecom.value !== undefined) evt.value = ecom.value;
    }
    evt.event = eventName;
    w.dataLayer.push(evt);
    log(eventName, evt);
    return evt;
  }

  
  function setPageVars(extra) {
    var vars = commonFields();
    delete vars.event_id;
    for (var k in (extra || {})) vars[k] = extra[k];
    w.dataLayer.push(clean(vars));
    log('page vars', vars);
  }

  /* ---------------------------------------------------------------- */
  
  /* ---------------------------------------------------------------- */

  

  
  var OBSERVE_STEPS = (function () {
    var arr = [];
    for (var i = 0; i <= 20; i++) arr.push(i / 20);
    return arr;
  })();

  var RATIO_EPS = 1e-4;   

  function effectiveRatio(elHeight, wanted) {
    var vh = w.innerHeight || d.documentElement.clientHeight || 0;
    if (!elHeight || !vh) return wanted;
    var maxPossible = Math.min(1, vh / elHeight);
    if (maxPossible >= wanted) return wanted;
    
    return Math.max(0.005, maxPossible * 0.9);
  }

  function observe(el, opts, cb) {
    if (!el || typeof cb !== 'function') return function () {};
    opts = opts || {};
    var ratio = opts.ratio == null ? 0.5 : opts.ratio;
    var dwell = opts.dwell == null ? 1000 : opts.dwell;

    if (!('IntersectionObserver' in w)) return function () {};

    var io = null;
    var timer = null;
    var done = false;
    var boundH = 0;        
    var boundVH = 0;       
    var boundNeed = ratio; 
    var builds = 0;        
    var accumMs = 0;       
    var visibleSince = 0;

    function measure() {
      try { return el.getBoundingClientRect().height || 0; } catch (e) { return 0; }
    }
    function vh() { return w.innerHeight || d.documentElement.clientHeight || 0; }

    function build(h) {
      boundH = h;
      boundVH = vh();
      boundNeed = effectiveRatio(h, ratio);
      builds += 1;
      var th = OBSERVE_STEPS.slice();
      
      var exists = false;
      for (var i = 0; i < th.length; i++) if (Math.abs(th[i] - boundNeed) < RATIO_EPS) { exists = true; break; }
      if (!exists) { th.push(boundNeed); th.sort(function (a, b) { return a - b; }); }
      if (io) io.disconnect();
      io = new IntersectionObserver(onEntries, { threshold: th });
      io.observe(el);
    }

    
    function needsRebuild(h) {
      if (builds > 12) return false;          
      if (h <= 0) return false;
      if (boundH === 0) return true;
      
      if (Math.min(1, vh() / h) < boundNeed - RATIO_EPS) return true;
      if (Math.abs(h - boundH) / boundH > 0.1) return true;
      var cur = vh();
      if (boundVH && Math.abs(cur - boundVH) / boundVH > 0.05) return true;
      return false;
    }

    function cleanup() {
      if (timer) { w.clearTimeout(timer); timer = null; }
      if (io) { io.disconnect(); io = null; }
      d.removeEventListener('visibilitychange', onVis);
      w.removeEventListener('resize', onResize);
    }

    function stop() { done = true; cleanup(); }

    function onEntries(entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (done) return;
        var h = (entry.boundingClientRect && entry.boundingClientRect.height) || 0;

        if (needsRebuild(h)) {
          
          build(h);
          continue;
        }

        
        var visible = entry.isIntersecting && entry.intersectionRatio >= boundNeed - RATIO_EPS;

        
        if (h <= 0) visible = false;

        
        if (visible && d.visibilityState === 'hidden') visible = false;

        if (visible) {
          if (timer) continue;
          visibleSince = Date.now();
          (function (target, observedRatio, requiredRatio) {
            timer = w.setTimeout(function () {
              timer = null;
              done = true;
              accumMs += Date.now() - visibleSince;
              cleanup();
              try {
                cb(target, {
                  ratio_required: Math.round(requiredRatio * 100) / 100,
                  ratio_observed: Math.round(observedRatio * 100) / 100,
                  rule: requiredRatio < ratio - RATIO_EPS ? 'viewport_fill' : 'ratio_' + Math.round(ratio * 100),
                  
                  engaged_ms: accumMs
                });
              } catch (e) { log('observe cb error', e); }
            }, dwell);
          })(entry.target, entry.intersectionRatio, boundNeed);
        } else if (timer) {
          w.clearTimeout(timer);
          timer = null;
          if (visibleSince) { accumMs += Date.now() - visibleSince; visibleSince = 0; }
        }
      }
    }

    
    function onVis() {
      if (d.visibilityState === 'hidden' && timer) {
        w.clearTimeout(timer); timer = null;
        if (visibleSince) { accumMs += Date.now() - visibleSince; visibleSince = 0; }
      }
    }
    
    var resizeTimer = null;
    function onResize() {
      if (done) return;
      if (resizeTimer) w.clearTimeout(resizeTimer);
      resizeTimer = w.setTimeout(function () {
        if (done) return;
        var h = measure();
        if (h > 0) build(h);
      }, 250);
    }

    d.addEventListener('visibilitychange', onVis);
    w.addEventListener('resize', onResize, { passive: true });

    build(measure());

    return stop;
  }

  /* ---------------------------------------------------------------- */
  
  /* ---------------------------------------------------------------- */

  
  function isInteractive(el) {
    if (!el) return false;
    if (el.disabled === true) return false;
    
    if (el.getAttribute && el.getAttribute('disabled') != null) return false;
    var ariaDisabled = el.getAttribute && el.getAttribute('aria-disabled');
    if (ariaDisabled === 'true') return false;
    if (el.classList && (el.classList.contains('disabled') || el.classList.contains('pf-disabled'))) return false;
    var st;
    try { st = w.getComputedStyle(el); } catch (e) {}
    if (st && (st.pointerEvents === 'none' || st.display === 'none' || st.visibility === 'hidden')) return false;
    return true;
  }

  
  function hasNavigation(el) {
    if (!el) return false;
    var href = el.getAttribute('href') || el.getAttribute('data-href');
    if (!href) return false;
    if (href === '#' || /^javascript:/i.test(href)) return false;
    
    if (href.charAt(0) === '#') return false;
    return true;
  }

  
  function clickWillSucceed(evt, el, requireNavigation) {
    if (!isInteractive(el)) return false;
    if (evt && evt.defaultPrevented && requireNavigation !== false) return false;
    if (requireNavigation && !hasNavigation(el)) return false;
    return true;
  }

  /* ---------------------------------------------------------------- */
  
  /* ---------------------------------------------------------------- */
  
  var stagedNav = [];
  var navWatchBound = false;

  function flushStagedNav() {
    if (!stagedNav.length) return;
    var q = stagedNav;
    stagedNav = [];
    for (var i = 0; i < q.length; i++) {
      if (q[i].done) continue;
      q[i].done = 1;
      push(q[i].name, q[i].data);
    }
  }

  function bindNavWatch() {
    if (navWatchBound) return;
    navWatchBound = true;
    w.addEventListener('pagehide', flushStagedNav, true);
    w.addEventListener('beforeunload', flushStagedNav, true);
    w.addEventListener('popstate', flushStagedNav, true);
    d.addEventListener('visibilitychange', function () {
      if (d.visibilityState === 'hidden') flushStagedNav();
    }, true);
  }

  
  var NAV_CONFIRM_MS = 1500;

  function pushOnNavigation(name, data) {
    bindNavWatch();
    var task = { name: name, data: data, done: 0 };
    var from = w.location.href;
    stagedNav.push(task);
    var waited = 0;
    (function poll() {
      if (task.done) return;
      if (w.location.href !== from) { task.done = 1; push(name, data); return; }
      waited += 100;
      if (waited > NAV_CONFIRM_MS) { task.done = 1; log('跳转未发生，按规则丢弃', name); return; }
      w.setTimeout(poll, 100);
    })();
  }

  
  function navPush(evt, el) {
    if (!isInteractive(el)) return null;
    if (!hasNavigation(el)) return null;
    /* El plugin de menú (smartmenu/tmenu) intercepta el clic de navegación con preventDefault +
       navegación propia por JS. Antes, al estar defaultPrevented, se enviaba vía pushOnNavigation (en
       pagehide) → demasiado tarde: GTM no alcanzaba a procesar el evento ni a enviar el beacon, y el
       tag (nav_click, select_item…) NO disparaba. Ahora enviamos SIEMPRE de inmediato: esto corre en
       el microtask de afterTick (ya tras todo el dispatch, con defaultPrevented en su valor final, pero
       ANTES de que el navegador confirme la navegación, que es una tarea nueva). Es el mismo camino que
       logo_click (enlace normal no interceptado), que sí disparaba. hasNavigation ya garantiza que hay
       un destino real (no '#', no javascript:, no ancla de misma página). */
    return function (name, data) {
      push(name, data);
    };
  }

  
  
  var MICRO = (typeof w.queueMicrotask === 'function')
    ? function (fn) { w.queueMicrotask(fn); }
    : (typeof Promise === 'function')
      ? function (fn) { Promise.resolve().then(fn); }
      : function (fn) { w.setTimeout(fn, 0); };

  function afterTick(fn) {
    MICRO(function () {
      try { fn(); } catch (e) { log('afterTick 回调异常', e); }
    });
  }

  /* ---------------------------------------------------------------- */
  
  /* ---------------------------------------------------------------- */

  var cartHandlers = [];
  var CART_ENDPOINTS = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;

  
  var requestHandlers = [];

  
  var STATIC_ASSET = /\.(js|mjs|css|png|jpe?g|gif|webp|svg|woff2?|ttf|ico|map)(\?|$)/i;

  
  function anyRequestHandlerMatches(url, method) {
    var m = String(method || 'GET').toUpperCase();
    for (var i = 0; i < requestHandlers.length; i++) {
      var h = requestHandlers[i];
      try {
        if (!h.pattern.test(url)) continue;
        if ((m === 'GET' || m === 'HEAD') && STATIC_ASSET.test(url)) continue;
        if (h.methods && h.methods.indexOf(m) === -1) continue;
        return true;
      } catch (e) {}
    }
    return false;
  }

  function emitRequestSuccess(url, body, method) {
    var m = String(method || 'GET').toUpperCase();
    requestHandlers.forEach(function (h) {
      try {
        if (!h.pattern.test(url)) return;
        if ((m === 'GET' || m === 'HEAD') && STATIC_ASSET.test(url)) return;
        if (h.methods && h.methods.indexOf(m) === -1) return;
        h.cb(url, body, m);
      } catch (e) { log('request handler error', e); }
    });
  }

  
  function onRequestSuccess(pattern, cb, opts) {
    if (!pattern || typeof cb !== 'function') return;
    opts = opts || {};
    requestHandlers.push({
      pattern: pattern,
      cb: cb,
      
      methods: opts.methods || ['POST', 'PUT', 'PATCH']
    });
  }

  function endpointKind(url) {
    var m = String(url || '').match(/\/cart\/(add|change|update|clear)/i);
    return m ? m[1].toLowerCase() : null;
  }

  function emitCartSuccess(kind, url, body) {
    log('cart api success', kind, url, body);
    cartHandlers.forEach(function (h) {
      try { h(kind, body, url); } catch (e) { log('cart handler error', e); }
    });
  }

  function safeJSON(text) {
    try { return JSON.parse(text); } catch (e) { return null; }
  }

  function installCartInterceptors() {
    /* fetch */
    if (w.fetch) {
      var origFetch = w.fetch;
      w.fetch = function (input, init) {
        var url = '';
        var method = 'GET';
        try {
          url = typeof input === 'string' ? input : (input && input.url) || '';
          method = (init && init.method) || (input && input.method) || 'GET';
        } catch (e) {}
        var p = origFetch.apply(this, arguments);
        
        if (url && anyRequestHandlerMatches(url, method)) {
          p.then(function (res) {
            if (!res || !res.ok) return res;
            try {
              res.clone().text().then(function (txt) {
                emitRequestSuccess(url, safeJSON(txt) || txt, method);
              }).catch(function () { emitRequestSuccess(url, null, method); });
            } catch (e) { emitRequestSuccess(url, null, method); }
            return res;
          }).catch(function () {});
        }
        if (url && CART_ENDPOINTS.test(url)) {
          p.then(function (res) {
            if (!res || !res.ok) return res;
            try {
              res.clone().json().then(function (body) {
                emitCartSuccess(endpointKind(url), url, body);
              }).catch(function () {
                emitCartSuccess(endpointKind(url), url, null);
              });
            } catch (e) {
              emitCartSuccess(endpointKind(url), url, null);
            }
            return res;
          }).catch(function () {  });
        }
        return p;
      };
    }

    /* XMLHttpRequest */
    if (w.XMLHttpRequest && w.XMLHttpRequest.prototype) {
      var proto = w.XMLHttpRequest.prototype;
      var origOpen = proto.open;
      var origSend = proto.send;
      proto.open = function (method, url) {
        try { this.__djiUrl = url; this.__djiMethod = method; } catch (e) {}
        return origOpen.apply(this, arguments);
      };
      proto.send = function () {
        var xhr = this;
        
        if (!xhr.__djiBound) {
          xhr.__djiBound = 1;
          xhr.addEventListener('load', function () {
            if (xhr.status < 200 || xhr.status >= 300) return;
            var u = xhr.__djiUrl || '';          
            if (!u) return;
            var body = safeJSON(xhr.responseText);
            if (CART_ENDPOINTS.test(u)) emitCartSuccess(endpointKind(u), u, body);
            if (anyRequestHandlerMatches(u, xhr.__djiMethod)) {
              emitRequestSuccess(u, body || xhr.responseText, xhr.__djiMethod);
            }
          });
        }
        return origSend.apply(this, arguments);
      };
    }
  }

  function onCartSuccess(cb) {
    if (typeof cb === 'function') cartHandlers.push(cb);
  }

  function fetchCart() {
    return fetch(w.Shopify && w.Shopify.routes && w.Shopify.routes.root ? w.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  /* ---------------------------------------------------------------- */
  
  /* ---------------------------------------------------------------- */

  var TOP_CATEGORIES = CTX.top_categories || [];

  function money(cents) {
    
    if (cents == null || cents === '' || typeof cents === 'boolean') return undefined;
    if (isNaN(cents)) return undefined;
    return Math.round(Number(cents)) / 100;
  }

  function productCollections(productId) {
    var map = w.__pagefly_product_collections || {};
    return map[String(productId)] || [];
  }

  
  
  function normCat(s) {
    return String(s || '').toLowerCase()
      .replace(/[áàäâ]/g, 'a').replace(/[éèëê]/g, 'e').replace(/[íìïî]/g, 'i')
      .replace(/[óòöô]/g, 'o').replace(/[úùüû]/g, 'u').replace(/ñ/g, 'n')
      .replace(/\s+/g, ' ').trim();
  }

  function splitCategories(collectionTitles, productType) {
    var cols = (collectionTitles || []).filter(Boolean);
    var tops = {};
    for (var t = 0; t < TOP_CATEGORIES.length; t++) tops[normCat(TOP_CATEGORIES[t])] = 1;
    var top = '';
    var series = '';
    for (var i = 0; i < cols.length; i++) {
      var isTop = tops[normCat(cols[i])] === 1;
      if (!top && isTop) { top = cols[i]; continue; }
      if (!series && !isTop && !/^Product Display/i.test(cols[i])) series = cols[i];
    }
    return {
      item_category: top || undefined,
      item_category2: series || undefined,
      item_category3: productType || undefined,
      item_series: series || undefined
    };
  }

  function categorize(product, productId) {
    return splitCategories(
      productCollections(productId).map(function (c) { return c && c.title; }),
      product && product.type
    );
  }

  function productCategories(productId) {
    var record = (CTX.product_categories || {})[String(productId || '')];
    var categories = record && record.categories || {};
    return {
      item_category: categories.item_category || undefined,
      item_category2: categories.item_category2 || undefined,
      item_category3: categories.item_category3 || undefined,
      item_series: categories.item_category2 || undefined
    };
  }

  
  function item(productId, extra) {
    extra = extra || {};
    var pid = String(productId || extra.item_id || '');
    var p = (w.__pageflyProducts || {})[pid] || null;

    var variant = null;
    if (p && p.variants && p.variants.length) {
      if (extra.variant_id) {
        for (var i = 0; i < p.variants.length; i++) {
          if (String(p.variants[i].id) === String(extra.variant_id)) { variant = p.variants[i]; break; }
        }
      }
      if (!variant) variant = p.selected_or_first_available_variant || p.variants[0];
    }

    var cat = productCategories(pid);

    var out = {
      item_id: pid || undefined,
      item_name: extra.item_name || (p && p.title) || undefined,
      item_brand: CTX.brand || 'DJI',
      item_category: cat.item_category,
      item_category2: cat.item_category2,
      item_category3: cat.item_category3,
      item_series: extra.item_series || cat.item_series,
      item_model: extra.item_model || (p && p.title) || undefined,
      item_variant: extra.item_variant || (variant && variant.title) || undefined,
      selected_variant_id: extra.variant_id ? String(extra.variant_id) : (variant && String(variant.id)) || undefined,
      product_handle: extra.product_handle || (p && p.handle) || undefined,
      availability: extra.availability || (variant ? (variant.available ? 'in_stock' : 'out_of_stock') : undefined),
      price: extra.price != null ? extra.price : money(variant && variant.price),
      quantity: extra.quantity == null ? 1 : extra.quantity,
      item_list_id: extra.item_list_id,
      item_list_name: extra.item_list_name,
      index: extra.index
    };
    return clean(out);
  }

  
  function itemsFromCartLines(lines, extra) {
    extra = extra || {};
    return (lines || []).map(function (line, i) {
      return item(line.product_id, {
        item_name: line.product_title || line.title,
        variant_id: line.variant_id,
        item_variant: line.variant_title || undefined,
        product_handle: line.handle,
        price: money(line.final_price != null ? line.final_price : line.price),
        quantity: line.quantity,
        index: extra.index != null ? extra.index : i,
        item_list_id: extra.item_list_id,
        item_list_name: extra.item_list_name,
        item_category: extra.item_category,
        item_series: extra.item_series
      });
    });
  }

  function itemsValue(items) {
    var v = 0;
    (items || []).forEach(function (it) {
      if (it.price != null) v += Number(it.price) * (it.quantity || 1);
    });
    return Math.round(v * 100) / 100;
  }

  /* ---------------------------------------------------------------- */
  
  /* ---------------------------------------------------------------- */

  
  function scrollDepth(opts, cb) {
    opts = opts || {};
    var thresholds = (opts.thresholds || [30, 50, 70, 100]).slice().sort(function (a, b) { return a - b; });
    var key = opts.key || 'scroll';
    var maxPct = 0;
    var ticking = false;

    
    onNewPageView(function () { maxPct = 0; });

    function docHeight() {
      return Math.max(
        d.documentElement.scrollHeight,
        d.body ? d.body.scrollHeight : 0
      );
    }

    function currentPct() {
      var total = docHeight();
      if (!total) return 0;
      var seen = (w.scrollY || w.pageYOffset || 0) + w.innerHeight;
      
      if (seen >= total - 2) return 100;
      return Math.min(100, Math.floor((seen / total) * 100));
    }

    function check() {
      ticking = false;
      var pct = currentPct();
      if (pct <= maxPct) return;
      maxPct = pct;
      for (var i = 0; i < thresholds.length; i++) {
        var t = thresholds[i];
        if (pct < t) continue;
        
        if (!once(key + '|' + t)) continue;
        try { cb(t, docHeight()); } catch (e) { log('scrollDepth cb error', e); }
      }
    }

    w.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      w.requestAnimationFrame(check);
    }, { passive: true });

    
    var stableH = -1;
    var settleTries = 0;
    function initialCheck() {
      var total = docHeight();
      var vh = w.innerHeight || 0;
      if (!total || !vh) return;

      if (total !== stableH) {
        
        stableH = total;
        if (++settleTries < 8) { w.setTimeout(initialCheck, 1200); }
        return;
      }
      
      if (total <= vh + 2) check();
    }
    w.setTimeout(initialCheck, 1200);
  }

  /* ---------------------------------------------------------------- */

  installCartInterceptors();

  w.DJIDataLayer = {
    push: push,
    setPageVars: setPageVars,
    common: commonFields,
    uuid: uuid,
    pageViewId: PAGE_VIEW_ID,
    once: once,
    onceSession: onceSession,
    newPageView: newPageView,
    onNewPageView: onNewPageView,
    observe: observe,
    scrollDepth: scrollDepth,
    deviceType: deviceType,
    onCartSuccess: onCartSuccess,
    onRequestSuccess: onRequestSuccess,
    fetchCart: fetchCart,
    item: item,
    productCategories: productCategories,
    splitCategories: splitCategories,
    itemsFromCartLines: itemsFromCartLines,
    itemsValue: itemsValue,
    money: money,
    sanitize: sanitize,
    isInteractive: isInteractive,
    hasNavigation: hasNavigation,
    clickWillSucceed: clickWillSucceed,
    afterTick: afterTick,
    clean: clean,
    log: log,
    ctx: CTX,
    navPush: navPush,
    pushOnNavigation: pushOnNavigation,
    debug: DEBUG
  };

  log('core ready', CTX);
})(window, document);
